import { ConceptWorkbook } from './ConceptWorkbook';
import { ScenarioPlayer } from './ScenarioPlayer';
import { DecisionTreePlayer } from './DecisionTreePlayer';
import { CaseStudyPlayer } from './CaseStudyPlayer';
import { DiagnosticPlayer } from './DiagnosticPlayer';
import { AudiobookPlayer } from './AudiobookPlayer';
import { PodcastPlayer } from './PodcastPlayer';
import { GenericModulePage } from './GenericModulePage';
import { EducateType } from '@/types/educate';
import type { EducateModule } from '@/hooks/useEducateModule';

export function ModuleRenderer({ module }: { module: EducateModule }) {
  switch (module.storyline?.educateType) {
    case EducateType.CONCEPT_WALKTHROUGH:
      return <ConceptWorkbook module={module} />;
    case EducateType.SCENARIO_LED:
      return <ScenarioPlayer module={module} />;
    case EducateType.DECISION_TREE:
      return <DecisionTreePlayer module={module} />;
    case EducateType.CASE_STUDY:
      return <CaseStudyPlayer module={module} />;
    case EducateType.DIAGNOSTIC:
      return <DiagnosticPlayer module={module} />;
    case EducateType.AUDIOBOOK:
      return <AudiobookPlayer module={module} />;
    case EducateType.PODCAST:
      return <PodcastPlayer module={module} />;
    default:
      return <GenericModulePage module={module} />;
  }
}
